module.exports = __webpack_public_path__ + "static/background-image-modal-ee615eba39668aab1abc52d23b1babdb.png";